<template>
  <div class="q-pa-md home-wrapper">
    <img class="banner" src="http://imgcdn.lanxiongsports.com/upload/shape/banner.png" alt>
    <h2>
      <i></i>
      <b></b>
      <span>2019健身教练最佳发展平台评选</span>
      <b></b>
      <i></i>
    </h2>
    <p class="desc">
      中国健身行业经历了近四年的迅猛发展，越来越多的人意识到，教练作为核心要素之一，对用户产生的价值和影响正越来越重要。具备长远眼光的健身房都在大举投入教练管理体系的建设，力求使挖掘和培养教练的过程标准化、规模化。这些体系的逐步建立将有助于当下中国健身行业的规范和升级。
      <br>
      <br>懒熊体育希望通过发起这次「健身教练最佳发展平台」评选，发掘中国健身行业的就业和职场深层现状，帮助教练人群找到更契合自身的平台，同时也能对未来健身房的人力资源管理提供借鉴。
      <br>
      <br>接下来我们需要你的关键一票。无论你是教练还是其他岗位的健身从业者，欢迎你在下面的四个维度中各选出三家你认为最优秀的机构。
      <br>
      <br>以下健身机构涵盖了目前行业中的知名品牌以及在评选征集中报名的品牌，此次大众投票的结果也将成为最终评选打分的参考之一。
    </p>
    <h2>
      <i></i>
      <b></b>
      <span>入选机构</span>
      <b></b>
      <i></i>
    </h2>
    <p class="copyright sub-title">（按照拼音顺序排序）</p>
    <div class="orgs">
      <ul>
        <!-- <li></li> -->
        <li v-for="item in orgs" :key="item">
          <img :src="item" alt>
        </li>
        <li class="hide"></li>
        <!-- <li class="hide"></li> -->
        <!-- <li class="hide"></li> -->
        <!-- <li class="hide"></li> -->
      </ul>
    </div>
    <h2>
      <i></i>
      <b></b>
      <span>投票规则</span>
      <b></b>
      <i></i>
    </h2>
    <p class="desc">
      投票时间：2019年4月21日--5月5日24:00
      <br>投票题目：每个题目只可以选择3家机构
      <br>投票限制：每位用户限投一次
    </p>
    <q-form>
      <Question
        v-for="(item, index) in questions"
        :key="item.title"
        @handleChange="handleChange"
        :options="item.options"
        :title="item.title"
        :value="values[`question[${index}+1]`]"
        :id="`question${index+1}`"
        :number="`${index+1}`"
      />
      <div class="btn-wrapper">
        <q-btn
          rounded
          type="submit"
          color="primary"
          @click.native="onSubmit"
          :size="'md'"
          :label="'提交'"
        />
        <!-- <div class="btn" @click="onSubmit">提交</div> -->
      </div>
    </q-form>
    <p class="copyright link">
      如有还未报名参选的机构，可通过以下链接报名参与，之后将被添加到上述投票机构列表中，
      链接：
      <a
        href="https://wj.qq.com/s2/3513427/48ee/"
        target="_blank"
      >https://wj.qq.com/s2/3513427/48ee/</a>，
      完成报名之后，我们的工作人员将会联系你并做进一步信息收集。此次评选的计分将包涵行业调研、专家评审、大众投票三个部分。需要注意的是，在最终统计时，只有完整报名的机构才能获得专家评审部分的计分。
    </p>
    <p class="copyright">*本活动解释权归懒熊体育所有</p>
  </div>
</template>

<style>
</style>

<script>
import Question from '@/components/Question'
import { questions, list } from './questions'
import { orgs } from './orgs'
import _request from '@/utils/request'
export default {
  data() {
    return {
      accept: false,
      values: {
        question1: '',
        question2: '',
        question3: '',
        question4: ''
      },
      questions,
      orgs
    }
  },
  methods: {
    async onSubmit() {
      for (const key in this.values) {
        if (this.values.hasOwnProperty(key)) {
          const element = this.values[key]
          if (element === '') {
            this.accept = false
            break;
          } else {
            this.accept = true
          }
        }
      }

      if (!this.accept) {
        this.$q.notify({
          color: 'yellow-7',
          textColor: 'black',
          icon: 'warning',
          message: '请不要遗漏选项',
          position: 'center',
          timeout: '1000'
        })

        for (const i of Object.keys(this.values)) {
          if (this.values[i] === '') {
            this.goAnchor(`#${i}`)
            break
          }
        }
      }
      else {
        const { values } = this
        const res = await _request.post('/selection/add', {
          isInterrupted: 0,
          value: `{
          "questionNum1": "${values.question1}",
          "questionNum2": "${values.question2}",
          "questionNum3": "${values.question3}",
          "questionNum4": "${values.question4}",
        }`
        })

        // 4 活动终止 5 已投票 0 成功 2 未知错误

        switch (~~res.respCode) {
          case 0:
            await this.$q.notify({
              color: 'positive',
              textColor: 'white',
              icon: 'thumb_up',
              message: '提交成功',
              position: 'center',
              timeout: '1000'
            })
            setTimeout(() => {
              this.$router.push('result')
            }, 2200)
            break;
          case 5:
            await this.$q.notify({
              color: 'warning',
              textColor: 'white',
              icon: 'warning',
              message: '您已投过票了',
              position: 'center',
              timeout: '1000'
            })
            break;
          case 4:
            await this.$q.notify({
              color: 'warning',
              textColor: 'white',
              icon: 'warning',
              message: '活动已终止',
              position: 'center',
              timeout: '1000'
            })
            break;
          case 2:
            this.$q.notify({
              color: 'negative',
              textColor: 'white',
              icon: 'warning',
              message: '出错了',
              position: 'center',
              timeout: '1000'
            })
            break;

          default:
            break;
        }
      }
    },
    handleChange(data) {
      const { selected, id } = data

      if (selected.toString() === '[]') {
        this.values[id] = ''
      } else {
        this.values[id] = selected.map(item => list[item]).join(',')
      }
    },
    goAnchor(selector) {
      let anchor = document.querySelector(selector)
      anchor.scrollIntoView()
    }
  },
  mounted() {
  },
  components: {
    Question
  }
}
</script>
<style lang="scss" src="./index.scss">
</style>

